import { daysBetween, istDateOf } from "./format";

export const earnings = (lead, pctKey) => {
  const net = (Number(lead.cash_collected) || 0) - (Number(lead.refund_amount) || 0);
  return Math.round(net * (Number(lead[pctKey]) || 0)) / 100;
};

const agingDays = (lead, today) => {
  if (lead.status !== "Follow-Up Ongoing") return null;
  const ref = lead.last_touch_date || istDateOf(lead.date_created);
  return ref ? daysBetween(ref, today) : null;
};
const bookingLagDays = (lead) => (lead.date_booked && lead.meeting_date ? daysBetween(lead.date_booked, lead.meeting_date) : null);
const depositUnpaidDays = (lead, today) => (
  Number(lead.deposit_amount) > 0 && !lead.date_paid_in_full && lead.deposit_date ? daysBetween(lead.deposit_date, today) : null);

const FLAG_RULES = [
  { key: "aging", days: agingDays, isLeak: (d) => d >= 7, label: (d) => `Aging ${d}d` },
  { key: "booking-lag", days: bookingLagDays, isLeak: (d) => d > 4, label: (d) => `Booking lag ${d}d` },
  { key: "deposit-unpaid", days: depositUnpaidDays, isLeak: (d) => d >= 14, label: (d) => `Deposit unpaid ${d}d` },
];

export const leadFlags = (lead, today) => FLAG_RULES
  .map((rule) => ({ rule, d: rule.days(lead, today) }))
  .filter(({ rule, d }) => d !== null && rule.isLeak(d))
  .map(({ rule, d }) => ({ key: rule.key, days: d, label: rule.label(d) }));

export const repOptions = (reps, kind, currentId) => {
  const roles = kind === "setter" ? ["Setter", "Both"] : ["Closer", "Both"];
  const list = reps.filter((r) => r.active && roles.includes(r.role));
  const current = reps.find((r) => r.id === currentId);
  if (current && !list.includes(current)) list.push({ ...current, name: `${current.name} (inactive)` });
  return list;
};
